import React, { useEffect } from "react";

import { useNavigate, Link, useLocation } from "react-router-dom";
import history from "../../history";
import { useDispatch, useSelector } from "react-redux";

// // // import './style.css';
import { setClearShop } from "../../modules/shop/actions";
import { setClearCategory } from "../../modules/category/actions";

const Inner = (props, test) => {
  const { header, content, dopClass, footer, title, load, loadPreview } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const theme = useSelector((state) => state.initData.theme);

  const handleBack = (e) => {
    e.preventDefault();

    if (dopClass == "_shop") {
      dispatch(setClearShop());
    }
    if (dopClass == "_category") {
      dispatch(setClearCategory());
    }
    if (location.key !== "default") {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, []);

  return (
    <div className={`page _inner ${dopClass}`}>
      <div className="page__bg"></div>
      {((theme == "dark" || theme == "light") && load && (
        <div className="page__load">{loadPreview}</div>
      )) || (
        <div className="page__wrap">
          <div className="page__header">
            <button className="page__header-back" onClick={handleBack}>
              {((theme == "dark" || theme == "light") && (
                <>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.25 16.5L3.75 9L11.25 1.5L13.125 3.375L7.5 9L13.125 14.625L11.25 16.5Z"
                      fill="#0F0F0F"
                    />
                  </svg>
                  Назад
                </>
              )) || (
                <>
                  {(typeof window !== "undefined" &&
                    window.innerWidth < 1023 &&
                    dopClass == "_shop" && (
                      <img src="https://cdn.podeli.ru/web-catalog/assets/img/icon-back-white.svg" />
                    )) || (
                    <img src="https://cdn.podeli.ru/web-catalog/assets/img/icon-back.svg" />
                  )}
                </>
              )}
            </button>
            {header}
          </div>
          {(theme == "dark" || theme == "light") && title && (
            <div className="page__title">
              <h1>{title}</h1>
            </div>
          )}
          <div className="page__content">{content}</div>
          {footer && <div className="page__footer">{footer}</div>}
        </div>
      )}
    </div>
  );
};

export default Inner;
